import styled from 'styled-components'
import { Link } from 'react-router-dom'

const StyledLink = styled(Link)`
    text-decoration: none;
    display: flex;
    justify-content: center;
    align-items: center;
`

export default StyledLink
